import { Link } from 'react-router-dom';

import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';

import AuthWrapper1 from './AuthWrapper1';
import AuthCardWrapper from './AuthCardWrapper';
import AuthLogin from './authentication/auth-forms/AuthLogin';
import InfluencerLogo from '../../assets/influencer-logo.png';
import { BRAND_LOGIN_CSS } from './brandLoginStyles';

const Login = ({
  goToDiscover,
  goToCreatorApp,
  toggleLogin,
  goToForgotPassword,
  showDomainInvalidModal,
}) => {
  // A plain window.matchMedia() read only reflects the width at first paint,
  // and the app's viewport meta is still settling then -- the layout used to
  // land on the desktop branch only because an unrelated useMediaQuery call
  // happened to force a second render. This subscribes properly, so the card
  // moves off the banner as soon as there is room for it.
  const isDesktop = useMediaQuery('(min-width:768px)');

  return (
    <AuthWrapper1>
      <style>{BRAND_LOGIN_CSS}</style>
      <div 
        style={{ 
        zIndex: 0,
        position: 'fixed',   
        backgroundImage: `url(https://influencer-media.s3.ap-south-1.amazonaws.com/signup_banner.png)`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        height: '100vh',
        width: '60vw',
        left: 0,
        right: 0 }} />
      <Grid
        className="bl-login"
        container
        direction="column"
        justifyContent={isDesktop ? 'flex-end' : 'center'}
        sx={{ minHeight: '100vh' }}
      >
        <Grid item xs={12}>
          <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
            {isDesktop ? <div style={{ flex: 1 }} /> : null}
            <Grid
              item
              sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}
              style={{
                height: isDesktop ? '100vh' : '95%',
                zIndex: 1,
                background: 'white',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: isDesktop ? 'auto' : '95%',
                overflowY: 'scroll',
              }}
            >
              <AuthCardWrapper>
                <div className="bl-card">
                  <Link to="#" aria-label="logo" className="bl-card__logolink">
                    <img src={InfluencerLogo} alt="influencer-logo" className="bl-card__logo" />
                  </Link>
                  <h1 className="bl-card__title">Hi, Welcome Back</h1>
                  <p className="bl-card__lede">
                    Plan campaigns, shortlist creators and track what you have live.
                  </p>

                  <AuthLogin
                    goToDiscover={goToDiscover}
                    goToCreatorApp={goToCreatorApp}
                    showDomainInvalidModal={showDomainInvalidModal}
                    goToForgotPassword={goToForgotPassword}
                  />

                  <p className="bl-alt">
                    New here?{' '}
                    <button type="button" className="bl-link" onClick={toggleLogin}>
                      Create a brand account
                    </button>
                  </p>

                  <div className="bl-divider">
                    <span>ARE YOU A CREATOR?</span>
                  </div>
                  <p className="bl-alt">
                    <Link className="bl-link" to="/login/influencer">
                      Sign in to the creator dashboard
                    </Link>
                  </p>

                </div>
              </AuthCardWrapper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AuthWrapper1>
  );
};

export default Login;
